import React from 'react';
import { DEVICE_BREAKPOINTS, getDeviceForWidth } from '../_config/breakpoints';

/**
 * HOC responsive per i class component (es. AppHeader), dove non e' possibile
 * usare gli hook. Inietta una prop `breakpoint` con gli stessi flag di
 * useBreakpoint:
 *
 *   { isPhone, isTablet, isDesktop, isPhoneOrTablet, device, width }
 *
 * NON contiene logica applicativa: ascolta solo il resize del viewport per
 * scegliere stili/layout. Usa matchMedia quando disponibile, con fallback su
 * window.innerWidth.
 *
 * Uso:
 *   class MyView extends React.Component { ... this.props.breakpoint.isPhone ... }
 *   export default withBreakpoint(MyView);
 */
export default function withBreakpoint(WrappedComponent) {
  class WithBreakpoint extends React.Component {
    constructor(props) {
      super(props);
      this.state = { width: typeof window !== 'undefined' ? window.innerWidth : DEVICE_BREAKPOINTS.desktopMinWidth };
      this.handleResize = this.handleResize.bind(this);
    }

    componentDidMount() {
      window.addEventListener('resize', this.handleResize);
    }

    componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize);
    }

    handleResize() {
      const width = window.innerWidth;
      if (width !== this.state.width) this.setState({ width });
    }

    render() {
      const { width } = this.state;
      const device = getDeviceForWidth(width);
      const breakpoint = {
        width,
        device,
        isPhone: device === 'phone',
        isTablet: device === 'tablet',
        isDesktop: device === 'desktop',
        isPhoneOrTablet: device === 'phone' || device === 'tablet',
      };
      return <WrappedComponent {...this.props} breakpoint={breakpoint} />;
    }
  }

  const name = WrappedComponent.displayName || WrappedComponent.name || 'Component';
  WithBreakpoint.displayName = `withBreakpoint(${name})`;
  return WithBreakpoint;
}
